import { Component, Inject, Input, OnInit } from '@angular/core';

import { EventParticipantImage } from '@frontend/sports/betting-offer/feature/model';

import { UrlHelperService } from '../navigation-core/url-helper.service';
import { LcpCandidateDirective } from '../perf-cdk/lcp-candidate.directive';
import { HighlightsMarqueePage } from './highlights-marquee-page.enum';
import { HighlightsMarqueePageService } from './highlights-marquee-page.service';
import { Tile } from './marquee-tile.model';

@Component({
    template: '',
    hostDirectives: [LcpCandidateDirective],
    standalone: false,
})
export abstract class HighlightsCardComponent<T extends Tile> implements OnInit {
    @Input() page?: HighlightsMarqueePage;
    @Input() tile: T;
    @Input() preventNavigation: boolean;
    @Input() trackingPosition: number;
    @Input() images: EventParticipantImage[] = [];
    trackingSource: string;
    shouldRemoveHref: boolean;

    constructor(
        @Inject(String) protected trackingIdentifier: string,
        protected highlightsMarqueePageService: HighlightsMarqueePageService,
        protected urlHelper: UrlHelperService,
    ) {}

    ngOnInit(): void {
        const pageSource = this.page ? this.highlightsMarqueePageService.mapPageSource(this.page).toLowerCase() + '/' : '';

        this.trackingSource = pageSource + this.trackingIdentifier;
        this.shouldRemoveHref = this.urlHelper.shouldRemoveHref();
    }
}
